import { Label, Surface, Text } from '@elladx/design-system';
import type { ReactNode } from 'react';

/** Shared access card for sign-in, loading and recovery states. */
export default function AuthShell({ children }: { children: ReactNode }) {
  return (
    <main className="auth">
      <div className="auth-layout">
        <Surface className="auth-brand-panel" tone="inverse">
          <Text className="auth-brand-wordmark" tone="inverse">EasyPost</Text>
          <div className="auth-brand-content">
            <Label as="p" variant="eyebrow" tone="inverse">Shipping workspace</Label>
            <svg className="auth-route-art" viewBox="0 0 400 320" fill="none" aria-hidden="true" focusable="false">
              <rect x="88" y="4" width="224" height="308" rx="8" fill="var(--dx-color-surface)" />
              <g fill="var(--dx-color-text)" fontFamily="var(--dx-font-body)">
                <text x="108" y="32" fontSize="12" fontWeight="700">SHIPPING LABEL</text>
                <text x="108" y="55" fontSize="8">SAMPLE · NOT VALID FOR SHIPPING</text>
                <text x="108" y="91" fontSize="9" fontWeight="700">SHIP TO</text>
                <text x="108" y="166" fontSize="18" fontWeight="700">GROUND</text>
                <text x="108" y="190" fontSize="8">TRACKING NUMBER</text>
                <text x="108" y="206" fontSize="10">0000 0000 0000</text>
                <text x="200" y="293" fontSize="8" textAnchor="middle">SAMPLE LABEL</text>
              </g>
              <g stroke="var(--dx-color-text)">
                <path d="M108 69H292M108 145H292M108 177H292" strokeWidth="1" />
                <path d="M108 107H242M108 118H265M108 129H211" strokeWidth="4" opacity="0.45" />
                <path d="M110 221V274M119 221V274M134 221V274M140 221V274M153 221V274M166 221V274M176 221V274M185 221V274M198 221V274M216 221V274M229 221V274M242 221V274M248 221V274M264 221V274M279 221V274M289 221V274" strokeWidth="2" />
                <path d="M125 221V274M147 221V274M160 221V274M191 221V274M207 221V274M223 221V274M256 221V274M271 221V274" strokeWidth="5" />
              </g>
            </svg>
          </div>
        </Surface>
        <div className="auth-form">
          <div className="auth-mobile-brand">
            <Text className="auth-brand-wordmark">EasyPost</Text>
            <Label as="p" variant="caption">Shipping workspace</Label>
          </div>
          <Surface className="auth-card">
            <div className="auth-body">{children}</div>
          </Surface>
        </div>
      </div>
    </main>
  );
}
